import React from 'react'
import PropTypes from 'prop-types'

import { Image } from 'semantic-ui-react'

import { FAMILY_ALBUM_URL } from 'Global/constants'

import * as styles from './styles'

const FAEventCardPicture = ({ index, onClick, picture }) => {
  return <Image onClick={() => onClick(index)} src={`${FAMILY_ALBUM_URL}/${picture.edited}`} style={styles.picture} fluid />
}

FAEventCardPicture.propTypes = {
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  picture: PropTypes.object.isRequired,
}

export default FAEventCardPicture
